import type { ThemeKey, DefaultThemeStyles } from 'Src/types/theme';
import type { ReactNode } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import React, { Children } from 'react';
import Markdown from 'react-markdown';
import RemarkBreaks from 'remark-breaks';
import { HTML_ELEMENTS, markdownRootHeadingRenderer } from 'Components/utils/markdown/markdown';
import { themes } from './Heading.themes';
const MARKDOWN_ALLOWED_TYPES = [
  HTML_ELEMENTS.BREAK.type,
  HTML_ELEMENTS.EMPHASIS.type,
  HTML_ELEMENTS.PARAGRAPH.type,
  HTML_ELEMENTS.STRONG.type,
  HTML_ELEMENTS.TEXT.type,
] as const;
type Props = {
  children: string;
  className?: string;
  color?: Colors;
  hLevel?: number;
  theme?: ThemeKey<typeof themes>;
};

const HeadingText = ({ children }: { children: ReactNode }) => children;

export const Heading = ({
  children,
  className,
  hLevel = 1,
  theme = 'heading-brand-1',
  ...rest
}: Props) => {
  if (!Children.count(children)) {
    return null;
  }

  const { thRoot } = themes[theme] as DefaultThemeStyles<typeof themes>;
  return (
    <Markdown
      allowedTypes={
        [...MARKDOWN_ALLOWED_TYPES] as unknown as Array<
          | 'link'
          | 'text'
          | 'break'
          | 'blockquote'
          | 'code'
          | 'delete'
          | 'emphasis'
          | 'heading'
          | 'list'
          | 'listItem'
          | 'paragraph'
          | 'strong'
        >
      }
      className={classnames(thRoot, className)}
      plugins={[RemarkBreaks]}
      renderers={{
        root: markdownRootHeadingRenderer({ ...rest, hLevel }),
        paragraph: HeadingText,
      }}
    >
      {children}
    </Markdown>
  );
};
